import { useAuth } from "@/context/AuthContext";

// Shown when the server runs in "no outside contact" mode (a rehearsal copy or DEV): nothing the app
// would send (emails, texts, Xero) leaves it, so nobody mistakes it for the live app.
export function NoContactBanner() {
  const { user } = useAuth();
  if (!user?.no_outside_contact) return null;
  return (
    <div data-testid="no-contact-banner" role="status"
      className="px-4 py-1.5 text-center text-xs font-medium bg-amber-100 text-amber-900 border-b border-amber-300">
      Test copy: no outside contact. Emails, texts and Xero are switched off and scheduled jobs don't run.
    </div>
  );
}
